import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 16px;
    border-radius: 16px;
    background: ${theme.v2.colors.brand.gradientBlue};
    margin-bottom: 16px;

    @media (max-width: ${theme.breakpoints.sm}) {
      flex-direction: column;
      gap: 8px;
      border-radius: 0px;
    }
  `}
`;

export const AnimationWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    background: ${theme.v2.colors.white.primary};
    border-radius: 50%;
    height: 32px;
    min-width: 32px;
    overflow:  hidden;
  `}
`;

export const AnimationIcon = styled.img`
  height: 32px;
  width: 32px;
`;

export const TextWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 16px;
    color: ${theme.v2.colors.white.primary};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm};
  `}
`;

export const Description = styled.div`
  ${({ theme }) => css`
    line-height: ${theme.v2.font.lineHeight.text};
  `}
`;

export const ButtonWrapper = styled.div``;
